import { axios } from '@/plugins/axios';

interface CalendarOptions {
  calendarId?: number;
  eventId?: number;
  data?: object;
}
interface CalendarDateOptions {
  start?: string | Date;
  end?: string | Date;
  data?: object;
  year?: number;
  month?: number;
  day?: number;
  hour?: number;
  minute?: number;
  second?: number;
}

interface CalendarOccurrenceInviteOptions {
  calendarId: number;
  eventId: number;

  occurrenceId?: number;

  token: string;

  rsvp: number;
}

export class CalendarService {
  private endpoint: string;
  private eventEndpoint = 'events/';
  constructor() {
    this.endpoint = 'v1/eventcal/calendars/';
  }

  async fetchCalendars(event: string) {
    return axios
      .get(`${this.endpoint}?event=${event}`)
      .then(({ data }) => data);
  }

  async fetchCalendar(options: CalendarOptions) {
    return axios
      .get(`${this.endpoint}${options.calendarId}`)
      .then(({ data }) => data);
  }

  async createCalendar(payload: object) {
    return axios.post(`${this.endpoint}`, payload).then(({ data }) => data);
  }

  async updateCalendar(calId: number, payload: object) {
    return axios
      .patch(`${this.endpoint}${calId}`, payload)
      .then(({ data }) => data);
  }

  async deleteCalendar(calId: number) {
    return axios.delete(`${this.endpoint}${calId}/`);
  }

  async optionsCalendar(calId: number) {
    return axios({ method: 'options', url: `${this.endpoint}${calId}/` }).then(
      ({ data }) => data
    );
  }

  async optionsCalendars() {
    return axios({ method: 'options', url: `${this.endpoint}` }).then(
      ({ data }) => data
    );
  }

  async fetchCalendarEvents(calId: number) {
    return axios
      .get(`${this.endpoint}${calId}/${this.eventEndpoint}`)
      .then(({ data }) => data);
  }

  async fetchCalendarEvent(calId: number, eventId: number) {
    return axios
      .get(`${this.endpoint}${calId}/${this.eventEndpoint}${eventId}/`)
      .then(({ data }) => data);
  }

  async createCalendarEvent(options: CalendarOptions) {
    return axios
      .post(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}`,
        options.data
      )
      .then(({ data }) => data);
  }

  async updateCalendarEvent(calId: number, eventId: number, data: object) {
    return axios
      .patch(`${this.endpoint}${calId}/${this.eventEndpoint}${eventId}/`, data)
      .then(({ data }) => data);
  }

  async sendCalendarEventInvite(options: CalendarOptions) {
    return axios
      .post(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/invite/`
      )
      .then(({ data }) => data);
  }

  async getCalendarEventInvite(options: CalendarOccurrenceInviteOptions) {
    return axios
      .get(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/token/${options.token}/rsvp/${options.rsvp}/`,
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => data);
  }

  async deleteCalendarEvent(options: CalendarOptions) {
    return axios.delete(
      `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/`
    );
  }
  async fetchCalendarOccurrences(
    options: CalendarOptions,
    date: CalendarDateOptions
  ) {
    return axios
      .get(
        `${this.endpoint}${options.calendarId}/occurrences/?start=${date.start}&end=${date.end}`
      )
      .then(({ data }) => data);
  }
  async sendCalendarOccurrenceInvite(
    options: CalendarOptions,
    date: CalendarDateOptions
  ) {
    return axios
      .post(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/occurrences/${date.year}/${date.month}/${date.day}/${date.hour}/${date.minute}/${date.second}/invite/`
      )
      .then(({ data }) => data);
  }
  async getCalendarOccurrenceInvite(options: CalendarOccurrenceInviteOptions) {
    // TODO: inquire about url path inconsistency
    return axios
      .get(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/occurrences/${options.occurrenceId}/token/${options.token}/rsvp/${options.rsvp}/`,
        {
          headers: {
            Authorization: null
          }
        }
      )
      .then(({ data }) => data);
  }
  async fetchCalendarOccurrence(
    options: CalendarOptions,
    date: CalendarDateOptions
  ) {
    return axios
      .get(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/occurrences/${date.year}/${date.month}/${date.day}/${date.hour}/${date.minute}/${date.second}/`
      )
      .then(({ data }) => data);
  }
  async updateCalendarOccurrence(
    options: CalendarOptions,
    date: CalendarDateOptions,
    data: object
  ) {
    return axios
      .put(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/occurrences/${date.year}/${date.month}/${date.day}/${date.hour}/${date.minute}/${date.second}/`,
        data
      )
      .then(({ data }) => data);
  }
  async deleteCalendarOccurrence(
    options: CalendarOptions,
    date: CalendarDateOptions
  ) {
    return axios
      .delete(
        `${this.endpoint}${options.calendarId}/${this.eventEndpoint}${options.eventId}/occurrences/${date.year}/${date.month}/${date.day}/${date.hour}/${date.minute}/${date.second}/`
      )
      .then(({ data }) => data);
  }
}
